// extracted by mini-css-extract-plugin
export default {"brandListContainer":"style_brandListContainer__8E9e8","brandItem":"style_brandItem__STTMK","brandImage":"style_brandImage__YmlAs"};